import './SkipLinks.scss';

import classnames from 'classnames';

import { appConfig } from './config';
import { t } from './i18n/i18n';
import { Link } from './router/Link';

export interface SkipLinksProps {
  className?: string;
}

export const SkipLinks = ({ className }: SkipLinksProps) => {
  return (
    <div className={classnames('skip-to', className)}>
      {appConfig.showSkipLinksBanner && (
        <Link className="skip-link" to={appConfig.skipLinks?.banner ?? '#banner'}>
          {t('accessibility.skip.banner')}
        </Link>
      )}
      {appConfig.showSkipLinksMain && (
        <Link className="skip-link" to={appConfig.skipLinks?.mainContent ?? '#main-content'}>
          {t('accessibility.skip.main')}
        </Link>
      )}
      {appConfig.showSkipLinksFooter && (
        <Link className="skip-link" to={appConfig.skipLinks?.footer ?? '#footer'}>
          {t('accessibility.skip.footer')}
        </Link>
      )}
    </div>
  );
};
